module.exports = __webpack_public_path__ + "static/media/procedureChi.281a17b1.png";